import React from 'react'
import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import { ChangeAmountForm } from './changeAmountForm/component'
import { setChangedAmountData, setError } from './changeAmountForm/model'
import { transactionRequestStatus } from '../../../const'
import { WithdrawalEdit } from '../../edit'
import { Alert, Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'

type Props = {
  disabled?: boolean
  withdrawal: WithdrawalEdit
  errorAmount: { message: string }
  success: { message: string }
}

export const ChangeAmountsModal: React.FC<Props> = ({
  disabled,
  withdrawal,
  errorAmount,
  success,
}) => {
  const [isVisible, setVisible] = React.useState(false)
  const {
    initialAmount,
    initialCurrency,
    clientAmount,
    clientCurrency,
    exchangeRate,
    companyAmount,
    companyCurrency,
    companyCommission,
    clientCommission,
    innerCommission,
    initialAmountUsd,
    status,
  } = withdrawal

  return (
    <>
      {[
        transactionRequestStatus.pendingManager(),
        transactionRequestStatus.questions(),
        transactionRequestStatus.missingInformation(),
        transactionRequestStatus.fundsReserved(),
        transactionRequestStatus.accepted(),
      ].includes(status) && (
        <Button
          onClick={() => setVisible(true)}
          disabled={disabled}
          type="primary"
          icon={<EditOutlined />}
        />
      )}
      {isVisible && (
        <CModal
          visible={isVisible}
          onClose={() => {
            setVisible(false)
            setChangedAmountData(null)
            setError({
              message: '',
              code: 0,
            })
          }}
          size="xl"
        >
          <CModalHeader>
            <CModalTitle>Change amounts</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <ChangeAmountForm
              initialData={{
                initialAmount,
                initialCurrency,
                clientAmount,
                clientCurrency,
                exchangeRate,
                companyAmount,
                companyCurrency,
                companyCommission,
                clientCommission,
                innerCommission,
                initialAmountUsd,
              }}
              transactionStatus={status}
              onClose={() => {
                setVisible(false)
                setChangedAmountData(null)
              }}
            />
          </CModalBody>
        </CModal>
      )}

      {errorAmount.message.length > 0 && (
        <Alert
          message={`Error code: ${errorAmount.message}`}
          type="error"
          className="mb-3"
        />
      )}

      {success.message.length > 0 && (
        <Alert message={success.message} type="success" className="mb-3" />
      )}
    </>
  )
}
